import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateKey } from '../services/translate.service';

export type MenuSection = MenuSectionWithTranslation | MenuSectionWithoutTranslation;
export type MenuItem = MenuItemWithTranslation | MenuItemWithoutTranslation;

interface MenuItemWithTranslation {
	label: TranslateKey;
	icon: string;
	routerLink: string[];
	disabled: boolean;
}

interface MenuItemWithoutTranslation {
	label: TranslateKey;
	icon: string;
	routerLink: string[];
	disabled: boolean;
}

interface MenuSectionWithoutTranslation {
	label: string;
	icon: string;
	translate: false;
	routerLink?: string[];
	items: MenuItemWithoutTranslation[];
	disabled?: boolean;
}

interface MenuSectionWithTranslation {
	label: TranslateKey;
	icon: string;
	translate?: boolean;
	routerLink?: string[];
	items: MenuItemWithTranslation[];
	disabled?: boolean;
}

@Injectable()
export class MenuService {
	private menuSource = new Subject<string>();
	private resetSource = new Subject();

	menuSource$ = this.menuSource.asObservable();
	resetSource$ = this.resetSource.asObservable();

	onMenuStateChange(key: string) {
		this.menuSource.next(key);
	}

	reset() {
		this.resetSource.next();
	}
}
